import * as React from "react"
import { Col } from "react-bootstrap"

import { ContactButton } from './ContactButton'
import Email from '../assets/img/email.svg'
import Soundcloud from '../assets/img/soundcloud.svg'
import Twitter from '../assets/img/twitter.svg'
import Bandcamp from '../assets/img/bandcamp.svg'
import Instagram from '../assets/img/instagram.svg'

export const Contact = () => {

    return (<>
        <Col sm="6" lg="2" className="justify-content-center d-flex">
            <ContactButton
                caption="Email"
                subcaption="will@willframpton.co.uk"
                href="mailto:will@willframpton.co.uk"
            >
                <Email />
            </ContactButton>
        </Col>

        <Col sm="6" lg="2" className="justify-content-center d-flex">
            <ContactButton
                caption="Instagram"
                subcaption="@willframptonmusic"
                href="https://www.instagram.com/willframptonmusic/"
            >
                <Instagram />
            </ContactButton>
        </Col>

        <Col sm="6" lg="2" className="justify-content-center d-flex">
            <ContactButton
                caption="Twitter"
                subcaption="@will_frampton"
                href="https://twitter.com/will_frampton"
            >
                <Twitter />
            </ContactButton>
        </Col>

        <Col sm="6" lg="2" className="justify-content-center d-flex">
            <ContactButton
                caption="Bandcamp"
                subcaption="willframpton"
                href="https://willframpton.bandcamp.com"
            >
                <Bandcamp />
            </ContactButton>
        </Col>
        
        <Col sm="6" lg="2" className="justify-content-center d-flex">
            <ContactButton
                caption="Soundcloud"
                subcaption="william-frampton"
                href="https://soundcloud.com/william-frampton"
            >
                <Soundcloud />
            </ContactButton>
        </Col>
    </>)

}